// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"20837":"1c73507c785b0a55","33527":"18c49a5149530a7d","36589":"9e5544203774da6b","50988":"c90a9aafffb5b66e","82515":"440766797b3e56ec","88562":"f828c2e112845c3b"}[chunkId] + ".css";
};